import React from 'react'
import { IUiIcon } from '../../../types/ui'

export const IconLogout = (
	{
		size = 24,
		imgSize = 24,
		fill = 'none',
		stroke = 'currentColor'
	}: IUiIcon
) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
		     width={`${size}px`}
		     height={`${size}px`}
		     viewBox={`0 0 ${imgSize} ${imgSize}`}
		     fill={fill}
		     stroke={stroke}
		     strokeWidth="2"
		     strokeLinecap="round"
		     strokeLinejoin="round"
		     className="feather feather-log-out"
		>
			<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
			<polyline points="16 17 21 12 16 7"></polyline>
			<line x1="21" y1="12" x2="9" y2="12"></line>
		</svg>
	)
}